import React from 'react';
import Border from '../common/border';
import ActivityTitle from '../common/ActivityTitle';
import ImageCarousel from '../common/ImageCarousel';

export interface Vehicle {
  title: string;
  type: string;
  seatingCapacity: number;
  features: string[];
  imageUrl: string[];
  _id?: string;
}

interface VehiclesProps {
  vehicles: Vehicle[];
}

const Vehicles: React.FC<VehiclesProps> = ({ vehicles }) => {
  if (!vehicles || vehicles.length === 0) {
    return null;
  }

  return (
    <div className='mt-6'>
      <ActivityTitle title={'Vehicle Options'} className='' />
      <div className='flex flex-wrap gap-5 pb-2 mt-2 w-full'>
        {vehicles.map((v, idx) => {
          const hasFeatures = v.features && v.features.length > 0;

          const vehicleCard = (
            <div style={{ width: '135px' }}>
              <div
                style={{ width: '135px', height: '77px' }}
                className='mb-2 overflow-hidden rounded-[8px]'
              >
                <ImageCarousel
                  images={v.imageUrl || []}
                  alt={v.title}
                  className='h-full w-full'
                  imageClassName='object-cover rounded-[8px]'
                  showNavigation={true}
                  navigationId={`vehicle-${idx}`}
                  buttonSize='sm'
                  loop={false}
                  enableFullscreen={true}
                  fullscreenTitle={v.title}
                />
              </div>
              <h4
                className='text-[12px] font-normal text-black leading-[15px] mb-1 overflow-hidden'
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {v.title}
              </h4>
              <div className='space-y-0.5'>
                {v.type && (
                  <p className='text-[10px] text-darkgrey capitalize'>
                    Type: {v.type}
                  </p>
                )}
                {v.seatingCapacity && (
                  <p className='text-[10px] text-darkgrey'>
                    Seats: {v.seatingCapacity}
                  </p>
                )}
                {hasFeatures && (
                  <div className='flex flex-wrap gap-1 mt-1'>
                    {v.features.slice(0, 3).map((f, i) => (
                      <span
                        key={`${f}-${i}`}
                        className='text-[8px] px-1 py-0.5 bg-gray-100 text-gray-700 rounded border border-gray-200'
                      >
                        {f}
                      </span>
                    ))}
                    {v.features.length > 3 && (
                      <span className='text-[8px] text-gray-500'>
                        +{v.features.length - 3}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          );

          return (
            <div key={`${v.title}-${idx}`} className='cursor-pointer'>
              {vehicleCard}
            </div>
          );
        })}
      </div>
      <Border />
    </div>
  );
};

export default Vehicles;
